import { getRequest, postRequest, patchRequest, deleteRequest } from 'services/requests';

export default {
    batchCourseGroups: (body) => patchRequest(`/batch/courses`, body),
    batchSendInvitations: (body) => postRequest(`/batch/courses/invitations`, body),
    batchDeleteGroups: (body) => postRequest(`/batch/courses/groups`, body),
};
